import { AuthActions } from '../../actions/constant';
import cookieService from '../../../services/tokenManagementService/cookiesStorageService';
import {
  therapistToken,
  therapistRefreshToken,
  therapistIdToken,
} from '../../../services/tokenManagementService/constant';
const { THERAPIST_LOGOUT_SUCCESS, THERAPIST_LOGOUT_FAILURE, THERAPIST_LOGOUT_RESET } = AuthActions;

const intialLogoutstate: object = {
  isLogOut: false,
  response: null,
};

export const therapistLogoutReducer = (state = intialLogoutstate, action: any) => {
  switch (action.type) {
    case THERAPIST_LOGOUT_SUCCESS: {   
      // localStorage.removeItem('subdomain');   
      cookieService.removeValue(therapistToken);
      cookieService.removeValue(therapistRefreshToken);
      cookieService.removeValue(therapistIdToken);
      return {
        ...state,
        isLogOut: true,
        response: action.payload,
      };
    }

    case THERAPIST_LOGOUT_FAILURE:
      return {
        ...state,
        isLogOut: false,
        response: action.payload,
      };

    case THERAPIST_LOGOUT_RESET:
      return intialLogoutstate;

    default:
      return state;
  }
};
